import React, {Component} from 'react';
import I18n from 'lib/i18n/i18n';
import ReactDOM from 'react-dom';


class HighestPayingBuyers extends Component {
    constructor(props){
        super(props);

        this.state = {
            showGraph: false
        };
    }

    componentDidMount() {
        const that = this;
        const script = document.createElement("script");
        const flag = 10;
        script.src = 'https://ssl.gstatic.com/trends_nrtr/1780_RC01/embed_loader.js';
        script.async = true
        ReactDOM.findDOMNode(this.refs.googleTrends).appendChild(script);
        script.onload = this.loadGoogleTrends.bind(script, that, flag);
    }

    loadGoogleTrends(that, flag){
        const keyword =  ((that.props.keyword || '') + ' Diamond Ring').trim();
        const geo = 'US';
        const months = I18n.getString('itemPage::trends::highestPayingBuyers::searchInMonths');
        const time = `today ${months}-m`;
        const exploreQuery = `q=${keyword.replace(/ /g, '%20')}&geo=${geo}&date=${time}`;
        trends.embed.renderExploreWidgetTo(ReactDOM.findDOMNode(that.refs.googleTrends),
            'GEO_MAP', {'comparisonItem':[{'keyword': keyword,'geo': geo,'time': time}],'category':0,'property':''},
            {'exploreQuery': exploreQuery,'guestPath':'https://trends.google.com:443/trends/embed/'});

        setTimeout(() => {
            let element = document.querySelectorAll('[id^=trends-widget]')
            if(element[0] && element[0].getAttribute('style')){
                that.setState({showGraph: true});
                return;
            }
            else{
                if(!flag){
                    that.setState({showGraph: false});
                    return;
                }
                that.refs.googleTrends.removeChild(element[0]);
                that.loadGoogleTrends(that, flag-1);
            }
        }, 1500);
    }

    render() {
        return(
            <div className={`graph ${this.state.showGraph ? 'show' : 'hide'}`}  id={`graph${this.props.id}`}>
                <h5 className="title">{I18n.getString('itemPage::trends::highestPayingBuyers::title')}</h5>
                <div ref="googleTrends"></div>
            </div>
        )
    }
}

export default HighestPayingBuyers;